import { transformAvailabilityCardDto, transformAvailabilityListDto, transformPreventiveCardDto, transformPreventiveListDto, } from '../../mappers/Reports/bi';
import { api } from './api';
export const BIApi = api.injectEndpoints({
    endpoints: (builder) => ({
        importBi: builder.mutation({
            query: data => ({
                url: 'api/pdcbi',
                method: 'post',
                data,
                formData: true,
            }),
        }),
        getAvailabilityCard: builder.query({
            query: cc => ({
                method: 'get',
                url: `/api/pdcbi/disponibilidade/totalizadores?${cc}`,
            }),
            transformResponse: (dto) => transformAvailabilityCardDto(dto),
        }),
        getAvailabilityList: builder.query({
            query: params => ({
                method: 'get',
                url: `/api/pdcbi/disponibilidade${params.cc ? `?${params.cc}` : ''} ${params.term ? `&${params.term}` : ''}`,
                params: {
                    itens: params.quantity || 5,
                    pagina: params.page || 1,
                    motivoOSFiltro: params.startDate || null,
                    tipoVeiculoFiltro: params.filter || null,
                },
            }),
            transformResponse: (dto) => transformAvailabilityListDto(dto),
        }),
        getPreventiveCard: builder.query({
            query: cc => ({
                method: 'get',
                url: `/api/pdcbi/preventiva/totalizadores?${cc}`,
            }),
            transformResponse: (dto) => transformPreventiveCardDto(dto),
        }),
        getPreventiveList: builder.query({
            query: params => ({
                method: 'get',
                url: `/api/pdcbi/preventiva${params.cc ? `?${params.cc}` : ''} ${params.term ? `&${params.term}` : ''}`,
                params: {
                    itens: params.quantity || 5,
                    pagina: params.page || 1,
                    statusFiltro: params.filter || null,
                },
            }),
            transformResponse: (dto) => transformPreventiveListDto(dto),
        }),
    }),
});
export const { useImportBiMutation, useLazyGetAvailabilityListQuery, useLazyGetPreventiveListQuery, useLazyGetAvailabilityCardQuery, useLazyGetPreventiveCardQuery, } = BIApi;
